import Axios from 'axios'
import config from '@/config'
import {
  getToken
} from '@/libs/util'
import {
  Notice
} from 'view-design'
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

export const setAuthorization = () => {
  axios.defaults.headers.Authorization = getToken() ? ('Bearer ' + getToken()) : ''
}

export const axios = Axios.create({
  baseURL: baseUrl,
  timeout: 120000,
  headers: {
    Authorization: 'Bearer ' + getToken()
  }
})

axios.interceptors.response.use((res) => {
  if (res.status != 200) {
    Notice.error({
      title: '网络错误',
      desc: res.data,
      duration: 2
    })
    return Promise.reject(res)
  }
  const resData = res.data
  if (resData.code != 200) {
    if (resData.code == 401) {
      Notice.warning({
        title: '提示',
        desc: '登录信息失效，请重新登录',
        duration: 2
      })
    } else if (resData.code == 403) {
      Notice.warning({
        title: '提示',
        desc: '无权限，请重新登录后尝试',
        duration: 2
      })
    } else {
      Notice.error({
        title: '提示',
        desc:  resData.msg,
        duration: 2
      })
    }
  }
  return resData
}, (error) => {
  if (error.response) {
    Notice.error({
      title: '网络错误',
      desc: error.response.status + ':' + error,
      duration: 2
    })
  } else {
    Notice.error({
      title: '网络错误',
      desc: error,
      duration: 2
    })
  }
  return Promise.reject(error)
})
